import React from "react";
import { useReservation } from "../../context/reservation";
import SummaryPanelHeader from "../common/SummaryPanelHeader";
import BookingPanelInfo from "../BookingPanelInfo"


function BookingDetailsSection() {
  const { data: reservation } = useReservation();

 
  const guests = reservation?.guest_group?.members;
//   const currentRegisteredGuests = guests?.length || 0;
  const totalGuests = reservation?.guest_group?.number_of_guests;
  const registrationStatus = guests?.length === totalGuests;

  return (
    <>
      <SummaryPanelHeader title="Booking Details" status={registrationStatus} />
      <BookingPanelInfo checkInDate={reservation?.check_in_date} checkOutDate={reservation?.check_out_date} />
    </>
  );
}

export { BookingDetailsSection };
